export default __webpack_public_path__ + "static/media/user-color.fd92d86a.svg";